import * as languagesList from './languagesList';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    languagesList: languagesList.IState
}

export const ActionCreators = {
    languagesList: languagesList.ActionCreators,
}

export const Reducers = combineReducers<IState>({
    languagesList: languagesList.Reducers,
});

export function* sagas() {
    yield all([
        fork(languagesList.sagas),
    ]);
}

